import { render, staticRenderFns } from "./pureList.vue?vue&type=template&id=1349986b&scoped=true"
import script from "./pureList.vue?vue&type=script&lang=js"
export * from "./pureList.vue?vue&type=script&lang=js"
import style0 from "./pureList.vue?vue&type=style&index=0&id=1349986b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349986b",
  null
  
)

export default component.exports